import * as React from "react"
import { cn } from "../utils/utils"

export function ModuleGrid({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn(
      // Mobile: 1 column with vertical gaps
      "grid grid-cols-1 gap-4",
      // Small tablets: 2 columns 
      "sm:grid-cols-2 sm:gap-x-6 sm:gap-y-6",
      // Large tablets/small desktop: 6 columns 
      "lg:grid-cols-6 lg:gap-x-8 lg:gap-y-6",
      // Desktop: maintain 6 columns with larger gaps
      "xl:gap-x-8 xl:gap-y-8",
      className
    )}>
      {children}
    </div>
  )
}